import { appendURLSearchParams } from '../../../../../../../utils/common/url.js';
import { LINK_PREVIEW_URLS } from '../LinkPreview.constants.js';

var fetchWebpageMetadata = function (_a) {
    var url = _a.url, apiKey = _a.apiKey, onSuccess = _a.onSuccess, _b = _a.onError, onError = _b === void 0 ? function () { } : _b, _c = _a.onFinally, onFinally = _c === void 0 ? function () { } : _c;
    if (!url)
        return;
    if (apiKey) {
        var request = fetch(appendURLSearchParams(LINK_PREVIEW_URLS.get_preview_data, {
            api_key: apiKey,
            url: url,
        }));
        request
            .then(function (data) { return data.json(); })
            .then(function (data) {
            if (data.error)
                throw new Error(data.error);
            if (onSuccess)
                onSuccess(data);
        })
            .catch(onError)
            .finally(onFinally);
    }
    else if (onError) {
        onError("Please provide API key.");
    }
};

export { fetchWebpageMetadata };
//# sourceMappingURL=fetchWebpageMetadata.js.map
